var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import LoadingContainer from '@/shared/components/loading/LoadingContainer';
import SimplePanel from '@/shared/components/SimplePanel';
import { CanCreate, showWhenPermission } from '@/shared/components/security';
import { features, functionalities, privileges } from '@/shared/services/AuthService';
import showWhenFeature from '@/shared/components/security/showWhenFeature';
import { useGetIntraCompanyOverview } from './hooks/useGetIntraCompanyOverview';
import IntraCompanyTable from './IntraCompanyTable';
import IntraCompanyFilters from './IntraCompanyFilters';
import messages from './messages';
import { initialFilters } from './helpers';
import useBillCompany from './hooks/useBillCompany';
import useBatchToggleIntraCompanyBilling from './hooks/useBatchToggleIntraCompanyBilling';
import Button from '@/shared/components/input/select/Button';
import useBatchBill from './hooks/useBatchBill';
import { useRowSelection } from '@/shared/hooks/useRowSelection';
var storageKey = 'IntraCompanyFilters';
var IntraCompanyBillingContainer = function (_a) {
    var stateService = _a.stateService;
    var intl = useIntl();
    var _b = useState(function () {
        return initialFilters(sessionStorage.getItem(storageKey), undefined);
    }), currentFilters = _b[0], setFilters = _b[1];
    var _c = useState({}), details = _c[0], setDetails = _c[1];
    var _d = useGetIntraCompanyOverview(currentFilters), data = _d.data, isLoading = _d.isLoading, reload = _d.reload, setIsProcessing = _d.setIsProcessing;
    var billCompany = useBillCompany().billCompany;
    var _e = useBatchBill(), batchBill = _e.batchBill, batchBillRunning = _e.batchBillRunning;
    var toggleIntraCompanyBilling = useBatchToggleIntraCompanyBilling().toggleIntraCompanyBilling;
    var _f = useRowSelection(), isSelected = _f.isSelected, resetSelected = _f.resetSelected, toggleSelected = _f.toggleSelected, hasAnySelected = _f.hasAnySelected, selectAll = _f.selectAll;
    useEffect(function () {
        sessionStorage.setItem(storageKey, JSON.stringify(currentFilters));
        setDetails({});
    }, [currentFilters]);
    var onBillCompany = useCallback(function (_a) {
        var relationCompanyId = _a.relationCompanyId, userCompanyId = _a.userCompanyId, key = _a.key;
        return __awaiter(void 0, void 0, void 0, function () {
            var result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, billCompany({
                            relationCompanyId: relationCompanyId,
                            userCompanyId: userCompanyId,
                            filters: currentFilters,
                        })];
                    case 1:
                        result = _b.sent();
                        setIsProcessing([key]);
                        if (result) {
                            reload();
                            setDetails({});
                        }
                        return [2 /*return*/];
                }
            });
        });
    }, [billCompany, currentFilters, reload]);
    var onBatchBill = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var selectedLines;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    selectedLines = data
                        .filter(function (x) { return isSelected(x.key); })
                        .map(function (_a) {
                        var relationCompanyId = _a.relationCompanyId, userCompanyId = _a.userCompanyId;
                        return ({
                            relationCompanyId: relationCompanyId,
                            userCompanyId: userCompanyId,
                        });
                    });
                    setIsProcessing(data.filter(function (x) { return isSelected(x.key); }).map(function (x) { return x.key; }));
                    return [4 /*yield*/, batchBill({
                            selectedLines: selectedLines,
                            filters: currentFilters,
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [batchBill, currentFilters, data, isSelected]);
    var onToggleIntraCompanyBilling = useCallback(function (_a) {
        var relationCompanyId = _a.relationCompanyId, userCompanyId = _a.userCompanyId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, toggleIntraCompanyBilling({
                            relationCompanyId: relationCompanyId,
                            userCompanyId: userCompanyId,
                            neverInvoice: !currentFilters.neverIntraCompany,
                            filters: currentFilters,
                        })];
                    case 1:
                        _b.sent();
                        reload();
                        setDetails({});
                        return [2 /*return*/];
                }
            });
        });
    }, [currentFilters, toggleIntraCompanyBilling, reload]);
    var updateFilters = function (filters) {
        setFilters(function (oldFilters) {
            var newFilters = __assign(__assign({}, oldFilters), filters);
            if (JSON.stringify(oldFilters) === JSON.stringify(newFilters))
                return oldFilters;
            return newFilters;
        });
    };
    var toggleDetails = function (key) {
        return setDetails(function (d) {
            var _a;
            return __assign(__assign({}, d), (_a = {}, _a[key] = !d[key], _a));
        });
    };
    var onSelectAll = function (selected) {
        if (selected) {
            selectAll(data.filter(function (x) { return !!x.relation && !x.isProcessing; }).map(function (x) { return x.key; }));
        }
        else {
            resetSelected();
        }
    };
    var isGlobalActionsDisabled = batchBillRunning || !hasAnySelected;
    return (_jsxs("div", { children: [_jsx(SimplePanel, __assign({ article: "12187295654684", title: intl.formatMessage(messages.IntraCompanyBilling) }, { children: _jsx("div", __assign({ className: "info-block container-fluid radius4B" }, { children: _jsx(IntraCompanyFilters, { filters: currentFilters, onFilterChange: updateFilters, intl: intl }) })) })), _jsxs(LoadingContainer, __assign({ isLoading: isLoading || !data }, { children: [data && data.length > 0 && (_jsx("div", __assign({ className: "row btn-row" }, { children: _jsx("div", __assign({ className: "col-md-6 pull-right content-right" }, { children: _jsx(CanCreate, __assign({ on: "IntraCompanyInvoice" }, { children: _jsx(Button, __assign({ disabled: isGlobalActionsDisabled, onClick: onBatchBill, className: "" }, { children: _jsx(FormattedMessage, __assign({}, messages.MakeInvoiceProposals)) })) })) })) }))), _jsx(IntraCompanyTable, { data: data, details: details, filters: currentFilters, onToggleDetails: toggleDetails, onBillCompany: onBillCompany, onToggleIntraCompanyBilling: onToggleIntraCompanyBilling, neverIntraCompany: currentFilters.neverIntraCompany, onToggleSelected: toggleSelected, isSelected: isSelected, onToggleAllSelected: onSelectAll })] }))] }));
};
export default showWhenPermission(functionalities.IntraCompanyInvoice, privileges.Read)(showWhenFeature(features.IntraCompanyBilling)(IntraCompanyBillingContainer));
